import type { Element } from 'react'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { Spinner } from 'app/assets/icons'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Text } from 'app/common/typography'

const { red4 } = colors

type Props = {
    loading: boolean,
    children?: Element<any>,
    color?: string,
    className?: string,
    loaderMessage?: string,
    size?: number
}

const _Loader = (props: Props) => {
    const {
        loading,
        children,
        color = red4,
        className,
        loaderMessage,
        size = 24
    } = props

    const renderLoaderMessage = () => {
        if (!!loaderMessage) {
            return (
                <FormattedMessage id={loaderMessage}>
                    {(text: string) => (
                        <Text center color={color}>
                            {text}
                        </Text>
                    )}
                </FormattedMessage>
            )
        }
        return null
    }

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Wrapper className={className}>
                        <Spinner color={color} size={size} />
                    </Wrapper>
                    {renderLoaderMessage()}
                </Container>
            ) : (
                <Fragment>{children}</Fragment>
            )}
        </Fragment>
    )
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    &.restaurant {
        height: 80px;
    }
`

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Loader = injectIntl(_Loader)

export { Loader }
